module.exports = __webpack_public_path__ + "img/SWP_Shield_01 (1).bdcbd923.png";